import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { AppShell } from '../layouts/AppShell';
import { Button } from '../components/ui/Button';
import { useAuth } from '../contexts/AuthContext';

export const PushSetup: React.FC = () => {
    const { isSupported, isRegistered, isLoading, subscribe } = usePushNotifications();
    const { user } = useAuth(); // Assume token is stored in localStorage or accessible. Actually, we just need ANY valid token. For now we will fetch from localStorage.
    
    // In many setups, token is in localStorage. We will pull it from there.
    const token = localStorage.getItem('token');

    const handleEnablePush = async () => {
        if (!token) return;
        const result = await subscribe(token);
        if (result) {
            alert('Push notifications enabled successfully!');
        } else {
            alert('Failed to enable push notifications');
        }
    };

    const handleTestPush = async () => {
        if (!token) return;
        try {
            await fetch('/api/push/test', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ message: "Hello from Vecindus!" })
            });
        } catch(e) {
            console.error("Test push error", e);
        }
    };

    return (
        <AppShell>
            <div className="p-6 max-w-2xl mx-auto bg-white rounded-lg shadow mt-8">
                <h2 className="text-2xl font-bold mb-4">Push Notifications</h2>
                
                {!isSupported && (
                    <div className="bg-red-50 p-4 rounded text-red-700">
                        Push notifications are not supported by your browser.
                    </div>
                )}
                
                {isSupported && !isRegistered && (
                    <div className="mb-4">
                        <p className="text-gray-600 mb-4">Enable push notifications to receive real-time updates for approvals, announcements, and tasks.</p>
                        <Button onClick={handleEnablePush} disabled={isLoading}>
                            {isLoading ? 'Enabling...' : 'Enable Push Notifications'}
                        </Button>
                    </div>
                )}
                
                {isRegistered && (
                    <div className="mb-4">
                        <div className="bg-green-50 p-4 rounded text-green-700 mb-4">
                            You are subscribed to push notifications!
                        </div>
                        <Button onClick={handleTestPush} variant="secondary">
                            Test Push Notification
                        </Button>
                    </div>
                )}
                 <div className="mt-8 text-sm text-gray-500 border-t pt-4">
                  Note: A valid VAPID public key must be configured in environments.
                </div>
            </div>
        </AppShell>
    );
};
